import {
  NEWS_ARTICLES, NEWS_ARTICLE, NEWSROOM, NEWS_MEDIA,
} from '../../../graphql/news';
import { client } from '../../utilities/config';

export const NEWS_PAGE_SIZE = 12;

export const getNewsArticles = ({ search, page = 1, first = NEWS_PAGE_SIZE } = {}) => client.query({
  query: NEWS_ARTICLES,
  variables: { search: search || null, page, first },
});

export const getNewsArticle = slug => client.query({
  query: NEWS_ARTICLE,
  variables: { slug },
});

export const getNewsroom = () => client.query({
  query: NEWSROOM,
});

export const getNewsMedia = type => client.query({
  query: NEWS_MEDIA,
  variables: { type },
});
